import { useCallback, useMemo } from "react"
import {
  trackMetricsSelectorOpened,
  trackMetricsSelectorClosed,
  trackMetricSelected,
  trackMetricDeselected,
  trackMetricsSelectorSearchPerformed,
  trackMetricsCategoryExpanded,
  trackMetricsCategoryCollapsed,
  trackCustomViewSaved,
  trackCustomViewUpdated,
  trackCustomViewDeleted,
  trackMetricsSelectorPermissionsClicked,
} from "../analytics"

export function useMetricsSelectorAnalytics(context, moduleType) {
  const trackOpened = useCallback((/** @type {import("resources/templates").TemplateResponse | null | undefined} */ templateMetadata = null) => {
    trackMetricsSelectorOpened(context, moduleType, templateMetadata)
  }, [context, moduleType])

  const trackClosed = useCallback((/** @type {import("resources/templates").TemplateResponse | null | undefined} */ templateMetadata = null) => {
    trackMetricsSelectorClosed(context, moduleType, templateMetadata)
  }, [context, moduleType])

  const trackMetricToggled = useCallback((metricId, isSelected) => {
    if (isSelected) {
      trackMetricSelected(context, moduleType, metricId)
    } else {
      trackMetricDeselected(context, moduleType, metricId)
    }
  }, [context, moduleType])

  const trackSearchPerformed = useCallback((searchTerm) => {
    trackMetricsSelectorSearchPerformed(context, moduleType, searchTerm)
  }, [context, moduleType])

  const trackCategoryExpanded = useCallback((categoryId) => {
    trackMetricsCategoryExpanded(context, moduleType, categoryId)
  }, [context, moduleType])

  const trackCategoryCollapsed = useCallback((categoryId) => {
    trackMetricsCategoryCollapsed(context, moduleType, categoryId)
  }, [context, moduleType])

  const trackViewSaved = useCallback((viewName, metricsCount) => {
    trackCustomViewSaved(context, moduleType, viewName, metricsCount)
  }, [context, moduleType])

  const trackViewUpdated = useCallback((templateId, viewName, metricsCount) => {
    trackCustomViewUpdated(context, moduleType, templateId, viewName, metricsCount)
  }, [context, moduleType])

  const trackViewDeleted = useCallback((templateId, viewName) => {
    trackCustomViewDeleted(context, moduleType, templateId, viewName)
  }, [context, moduleType])

  const trackPermissionsClicked = useCallback((templateId, viewName) => {
    trackMetricsSelectorPermissionsClicked(context, moduleType, templateId, viewName)
  }, [context, moduleType])

  return useMemo(() => ({
    trackOpened,
    trackClosed,
    trackMetricToggled,
    trackSearchPerformed,
    trackCategoryExpanded,
    trackCategoryCollapsed,
    trackViewSaved,
    trackViewUpdated,
    trackViewDeleted,
    trackPermissionsClicked,
  }), [
    trackOpened,
    trackClosed,
    trackMetricToggled,
    trackSearchPerformed,
    trackCategoryExpanded,
    trackCategoryCollapsed,
    trackViewSaved,
    trackViewUpdated,
    trackViewDeleted,
    trackPermissionsClicked,
  ])
}
